module.exports = __webpack_public_path__ + "static/urban4-79632988da3958051582094af57a2c12.jpg";